import { useRouter } from 'next/router';

import { useQuery } from 'react-query';
import { Explore } from 'services/explore';

const useExploreData = () => {
	const router = useRouter();
	const queryParams = router.query;
	const searchParams = Object.keys(queryParams).reduce((result, currentKey) => {
		const newKeyValue = `&${currentKey}=${queryParams[currentKey]}`;
		return result + newKeyValue;
	}, '?page_size=10');
  
	const queryResponse = useQuery(
		['explore-content', searchParams],
		() => Explore.GET(searchParams),
		{
			cacheTime: 0,
			staleTime: 0,
			enabled: !!router.isReady
		}
	);

	return {
		...queryResponse
	};
};

export default useExploreData;
